export const CONFIG = {
  default: { spacerHeight: 110, endSpace: 80 },
};
